<template>
  <div>
    <v-card>
      <v-card-title>
        Pricing
      </v-card-title>
      <v-card-text>
        <span v-if="!companyId"
          >This company isn't setup in the Partner Platform yet, no pricing data
          available.</span
        >

        <v-data-table
          v-else
          item-key="key"
          :loading="loading"
          :headers="headers"
          :items="items"
          :items-per-page="10"
          class="elevation-0"
          :expanded.sync="expanded"
          show-expand
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-5">
              <div>
                <v-row>
                  <v-col>
                    <h3>Pricing overrides</h3>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th v-if="!item.key.includes('subscription')">
                            CPC
                          </th>
                          <th v-else>Monthly Price</th>
                          <th>Pricing Period</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cost in item.override" :key="cost.id">
                          <td>{{ cost.overrides | dollarsCents }}</td>
                          <td>
                            {{ cost.startDate | date }} -
                            {{ cost.expireDate | date }}
                          </td>
                          <td>
                            <v-btn
                              depressed
                              color="primary"
                              :to="{
                                name: 'EditSubscriptionPricingOverride',
                                params: {
                                  facilityId: item.facilityExternalId,
                                  overrideId: cost.id
                                }
                              }"
                              >Edit</v-btn
                            >
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !item.override ||
                              (item.override && !item.override.length)
                          "
                        >
                          <td colspan="2"><i>No results found</i></td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <!-- ADD OVERRIDE BUTTON -->
                    <v-btn
                      v-if="item.key.includes('subscription')"
                      small
                      color="primary"
                      :to="{
                        name: 'AddSubscriptionPricingOverride',
                        params: { facilityId: item.facilityExternalId }
                      }"
                      >Add Override</v-btn
                    >
                  </v-col>

                  <v-col v-if="!item.key.includes('subscription')">
                    <h3>Market Pricing</h3>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>CPC</th>
                          <th>Price Period</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cost in item.cost" :key="cost.id">
                          <td>{{ cost.overrides | dollarsCents }}</td>
                          <td>
                            {{ cost.startDate | date }} -
                            {{ cost.expireDate | date }}
                          </td>
                        </tr>
                        <tr
                          v-if="!item.cost || (item.cost && !item.cost.length)"
                        >
                          <td colspan="2"><i>No results found</i></td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { getCompanyPricing } from "../../api/company";

export default {
  name: "Pricing",
  title: "Pricing",

  data() {
    return {
      loading: false,
      expanded: [],
      items: [],

      headers: [
        { text: "Product", value: "product" },
        { text: "Listing ID", value: "facilityExternalId" },
        { text: "Listing Name", value: "facilityName" },
        { text: "Current CPC", value: "price" },
        { text: "Price Period", value: "period" },
        { text: "", value: "data-table-expand" }
      ]
    };
  },

  props: {
    companyId: [Number, String]
  },

  async mounted() {
    await this.getPricing();
  },

  methods: {
    async getPricing() {
      this.loading = true;

      if (this.companyId) {
        const result = await getCompanyPricing(this.companyId);
        this.items = result.items;
      }

      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
